import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M6 7.5l-4 9.5h4l6 -15l-6 5.5","key":"svg-0"}],["path",{"d":"M22 20l-7 -15l-3 7l4 5l-8 3l14 0","key":"svg-1"}]]

const IconBrandAzure = createReactComponent('outline', 'brand-azure', 'BrandAzure', __iconNode);

export default IconBrandAzure;